import { Input } from "src/features/calculator/types/formula"

const TAX_ADJUSTMENT = 1
const ROUNDING_DECIMALS = 2
const MINIMUM_AMOUNT = 0

export function calcCustomerTransferFeeRate({
  exCustomerTransferFeeRate,
  consumptionTaxRate,
}: Input): number {
  const customerTransferFeeRate = exCustomerTransferFeeRate * (TAX_ADJUSTMENT + consumptionTaxRate)
  return parseFloat(customerTransferFeeRate.toFixed(ROUNDING_DECIMALS))
}

// 立替元本 = min(貸付上限額, 初期費用総額 - 頭金)
export function calcTotalReimbursement({
  maxAdvancePayment,
  initialCost,
  downPayment,
}: Input): number {
  return Math.min(maxAdvancePayment, initialCost - downPayment)
}

// 自己負担額 = max(初期費用総額 - 貸付上限額, 0) + 頭金
export function calcSelfPayment({ maxAdvancePayment, initialCost, downPayment }: Input): number {
  return Math.max(initialCost - maxAdvancePayment, MINIMUM_AMOUNT) + downPayment
}

// 送客手数料(税込) = 家賃 * 送客手数料率(税込)
export function calcCustomerTransferFee({ rent, customerTransferFeeRate }: Input): number {
  return Math.round(rent * customerTransferFeeRate)
}

// 立替送金額 = 立替元本 - 送客手数料(税込)
export function calcRemittance({ totalReimbursement, customerTransferFee }: Input): number {
  return totalReimbursement - customerTransferFee
}
